<!--
  Profile Overview — Pineapple 톤
  ────────────────────────────────────────
  · 자식 컴포넌트(BasicInfoCard / PasswordChangeCard / SideNav) 그대로 유지
  · 셸만 Pineapple 페이지 헤더 + ACard 래퍼로 변경
-->
<template>
  <div class="p-page">
    <a-page-head title="내 정보" :breadcrumbs="[{ label: '관리자' }, { label: '내 정보' }]">
    </a-page-head>

    <div class="p-profile-grid">
      <!-- 좌측 사이드 네비 -->
      <a-card padding="0">
        <side-nav :sections="userSideNav" />
      </a-card>

      <!-- 우측 컨텐츠 -->
      <div class="p-profile-main">
        <div v-if="loading" class="p-loader"><div class="p-spinner" /></div>

        <template v-else-if="userData">
          <basic-info-card
            :basic-data="userData"
            :is-user="true"
            @update-field="handleUpdateField"
            @save-changes="handleSaveChanges"
          />
          <password-change-card @update-password="handlePasswordChange" />
        </template>

        <a-empty v-else title="사용자 정보를 찾을 수 없습니다" />
      </div>
    </div>
  </div>
</template>

<script>
import BasicInfoCard from '@/views/users/components/BasicInfoCard.vue';
import PasswordChangeCard from '@/views/users/components/PasswordChangeCard.vue';
import SideNav from '@/views/users/components/SideNav.vue';
import APageHead from '@/components/Pineapple/APageHead.vue';
import ACard from '@/components/Pineapple/ACard.vue';
import AEmpty from '@/components/Pineapple/AEmpty.vue';

export default {
  name: 'UserDetail',
  components: { BasicInfoCard, PasswordChangeCard, SideNav, APageHead, ACard, AEmpty },
  data() {
    return {
      userId: null,
      userData: null,
      loading: false,
      updateFields: {},
      userSideNav: [
        { id: 'basic-info', icon: 'receipt_long', label: '기본 정보' },
        { id: 'password',   icon: 'lock',         label: '비밀번호 변경' },
      ],
    };
  },
  created() {
    this.userId = this.$store.state.auth.user_info.idx;
    this.loadUserData();
  },
  methods: {
    async loadUserData() {
      this.loading = true;
      try {
        const r = await this.$axios({
          method: 'get',
          url: `/roles/users/${this.userId}`,
          loadingBar: true,
        });
        if (r.status === 200) this.userData = r.data;
      } catch (e) {
        console.error('사용자 정보 로드 실패:', e);
        alert(e.response?.status === 404 ? '사용자를 찾을 수 없습니다.' : '사용자 정보를 불러오는데 실패했습니다.');
      } finally {
        this.loading = false;
      }
    },
    handleUpdateField({ field, value }) {
      this.updateFields = { ...this.updateFields, [field]: value };
    },
    async handleSaveChanges() {
      if (Object.keys(this.updateFields).length === 0) {
        alert('변경된 내용이 없습니다.');
        return;
      }
      try {
        await this.$axios({
          method: 'put',
          url: `/roles/users/${this.userId}`,
          data: this.updateFields,
        });
        alert('사용자 정보가 성공적으로 수정되었습니다.');
        this.updateFields = {};
        await this.loadUserData();
      } catch (e) {
        let msg = '사용자 정보 수정에 실패했습니다.';
        if (e.response?.status === 404) msg = '사용자를 찾을 수 없습니다.';
        else if (e.response?.data) {
          if (typeof e.response.data === 'string') msg = e.response.data;
          else if (e.response.data.detail) msg = e.response.data.detail;
          else if (e.response.data.message) msg = e.response.data.message;
        }
        alert(`${msg}\n\n상세 정보는 콘솔을 확인하세요.`);
      }
    },
    async handlePasswordChange({ current, new: newPassword }) {
      try {
        await this.$axios({
          method: 'post',
          url: '/auth/user/change-password',
          data: { current_password: current, new_password: newPassword },
          loadingBar: true,
        });
        alert('비밀번호가 변경되었습니다.');
      } catch (e) {
        console.error('비밀번호 변경 실패:', e);
        const msg = e?.response?.data?.detail || e?.response?.data?.message || '비밀번호 변경에 실패했습니다.';
        alert(msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_pineapple.scss';

.p-page {
  font-family: $p-font-body;
  color: $p-ink;
}

.p-profile-grid {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 16px;

  @media (max-width: 900px) { grid-template-columns: 1fr; }
}

.p-profile-main {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.p-loader { padding: 80px 0; text-align: center; }
.p-spinner {
  display: inline-block;
  width: 36px; height: 36px;
  border: 3px solid $p-line; border-top-color: $p-point;
  border-radius: 50%; animation: p-spin 0.8s linear infinite;
}
@keyframes p-spin { to { transform: rotate(360deg); } }
</style>
